import { ModelCreatableInterface } from '../interfaces/model-creatable.interface';
import { IntersectionType, PartialType, PickType } from '@nestjs/swagger';
import { ModelDto } from './model.dto';

export class ModelCreateDto
  extends IntersectionType(
    PickType(ModelDto, ['name', 'subdivisionId']),
    PartialType(
      PickType(ModelDto, [
        'externalId',
        'description',
        'garageFirst',
        'archived',
        'laborOnly',
        'stockingSpec',
        'highCeiling',
        'screwInspection',
        'active',
        'defaultTotalSquareFootage',
        'hasTrim',
        'hasInteriorOptions',
        'defaultInteriorOptionCost',
        'hasExteriorOptions',
        'defaultExteriorOptionCost',
        'hasTrimOptions',
        'defaultTrimOptionCost',
      ]),
    ),
  )
  implements ModelCreatableInterface {}
